// Canonical module/feature list used by Subscription Plans, Tenant creation and sidebar gating.
export const MODULE_OPTIONS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "tenants", label: "Tenants" },
  { key: "users", label: "Users" },
  { key: "departments", label: "Departments" },
  { key: "designations", label: "Designations" },
  { key: "locations", label: "Locations" },
  { key: "holidays", label: "Holidays & Calendar" },
  { key: "attendance", label: "Attendance" },
  { key: "attendance_reports", label: "Attendance Reports" },
  { key: "leaves", label: "Leaves" },
  { key: "documents", label: "Documents" },
  { key: "salary", label: "Salary Slips" },
  { key: "notices", label: "Notices" },
  { key: "resignations", label: "Resignations" },
  { key: "audit_logs", label: "Audit Logs" },
];

export const ALL_MODULE_KEYS = MODULE_OPTIONS.map((m) => m.key);

export const moduleLabel = (key) => MODULE_OPTIONS.find((m) => m.key === key)?.label || key;
